import { useContext } from "react";
import { useParams } from "react-router";
// @ts-ignore
import { DataRoomsContext } from "components/Contexts";

export function useSelectedDataRoom() {
  const { dataRoomKey } = useParams();
  const { dataRooms, loading }: { dataRooms: unknown[]; loading: boolean } = useContext(DataRoomsContext);
  if (dataRooms) {
    return {
      dataRoom: dataRooms.find(
        // @ts-ignore
        (data_room) => data_room.data_room === dataRoomKey,
      ),
      loading,
    };
  }
  return { loading };
}
